import { SaveFormDataAgendamiento } from "@/erp/operaciones/agendamiento/shared/interface/SaveFormDataAgendamiento.interface";
import { gridSizeMdLg12, gridSizeMdLg6, useMapComponent } from "@/shared";
import { IconBtnModalMapComponent } from "@/shared/components/erp";
import { CustomTextFieldNoForm } from "@/shared/components/ui";
import { Contrato } from "@/shared/interfaces";
import { Grid } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
type SaveFormData = SaveFormDataAgendamiento & {};
export type UbicacionPreagendamientoProps = {
    form: UseFormReturn<SaveFormData>
    contrato: Contrato
    errors: any

}
export default function AgendamientoOrdenServicioUbicacionContrato(
    {
        form,
        contrato
    }: UbicacionPreagendamientoProps
) {
    const { Map, latLng, napsByCity } = useMapComponent({
        form,
        currentCity: "",
        distanciaNapKey: "distancia",
        coordenadasCliente: contrato?.coordenadas,
        enabledFetchNaps: !!contrato?.coordenadas,
    });
    return (
        <>
            <CustomTextFieldNoForm
                label="País"
                defaultValue={contrato.pais_data?.nombre ?? ""}
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextFieldNoForm
                label="Provincia"
                defaultValue={contrato.provincia_data?.nombre ?? ""}
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextFieldNoForm
                label="Ciudad"
                defaultValue={contrato.ciudad_data?.nombre ?? ""}
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextFieldNoForm
                label="Zona"
                defaultValue={contrato.zona_data?.nombre ?? ""}
                size={gridSizeMdLg6}
                disabled
            />
            <Grid item xs={12} md={11}>
                <CustomTextFieldNoForm
                    disabled={true}
                    label={"Coordenadas"}
                    defaultValue={contrato?.coordenadas || ""}
                    size={gridSizeMdLg12}
                />
            </Grid>
            <Grid item xs={12} md={1}>
                <IconBtnModalMapComponent
                    coords={
                        `${latLng.lat},${latLng.lng}` ||
                        `${form.getValues().coordenadas}` ||
                        ""
                    }
                    btnColor="info"
                    showCustomMap
                    customMap={
                        <Map
                            coordenadas={latLng}
                            napsByCity={napsByCity || []}
                            canDragMarker={false}
                        />
                    }
                />
            </Grid>
            <CustomTextFieldNoForm
                label="Sector"
                defaultValue={contrato.sector_data?.nombre ?? ""}
                size={gridSizeMdLg12}
                disabled
            />
            <CustomTextFieldNoForm
                label="Dirección"
                defaultValue={contrato.direccion || ""}
                disabled
            />
        </>
    )
}